import { catchError, finalize, map, share } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs/observable/of';
import * as moment from 'moment';
import { ConfigService } from '@app/core/config.service';
import { COOKIES, ENDPOINTS } from '@app/app.constants';
import * as i0 from "@angular/core";
import * as i1 from "../../config.service";
import * as i2 from "ngx-cookie-service/cookie-service/cookie.service";
import * as i3 from "@angular/common/http";
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(configService, cookieService, httpClient) {
        this.configService = configService;
        this.cookieService = cookieService;
        this.httpClient = httpClient;
        this.baseUrl = this.configService.getValue('baseUrl');
        this.durationIsLoggedInCookie = this.configService
            .getValue(COOKIES.durationIsLoggedInCookie);
    }
    /**
     * Gets user authentication status and check if it is valid
     * @returns Auth status
     */
    AuthenticationService.prototype.getAndCheckStatus = function () {
        var _this = this;
        // Validation to avoid multiple http calls
        if (!this.observableAuthzStatus) {
            this.observableAuthzStatus = this.getStatus()
                .pipe(share(), map(function (response) {
                if (response.isLoggedIn) {
                    _this.setLoggedInCookie(response);
                }
                else {
                    _this.isLoggedInStatus = false;
                    _this.checkStatusCall = true;
                }
                return response.isLoggedIn;
            }), catchError(function () {
                _this.isLoggedInStatus = false;
                _this.checkStatusCall = true;
                return of(false);
            }), finalize(function () {
                delete _this.observableAuthzStatus;
            }));
        }
        return this.observableAuthzStatus;
    };
    /**
     * Gets user authentication status
     * @returns Log in status call
     */
    AuthenticationService.prototype.getStatus = function () {
        return this.httpClient.get("" + this.baseUrl + ENDPOINTS.authenticationStatus);
    };
    /**
     * Validates if user is logged in
     * @returns boolean value that indicates if user is logged in
     */
    AuthenticationService.prototype.isLoggedIn = function () {
        var isLoggedInCookie = this.cookieService.get(COOKIES.isLoggedIn);
        var loginDetails;
        try {
            loginDetails = JSON.parse(isLoggedInCookie);
        }
        catch (error) {
            loginDetails = null;
        }
        return !!loginDetails && loginDetails.isLoggedIn ? of(true) : this.checkStatus();
    };
    /**
     * Once the first status call has ended then
     * Check is page has fully loaded before making the next status call
     * @returns boolean value that indicates is user is logged in
     */
    AuthenticationService.prototype.checkStatus = function () {
        var isLoggedIn;
        if (this.checkStatusCall) {
            isLoggedIn = of(this.isLoggedInStatus);
        }
        else {
            isLoggedIn = this.getAndCheckStatus();
        }
        return isLoggedIn;
    };
    /**
     * Set checkStatusCall property
     * @param checkStatusCall
     */
    AuthenticationService.prototype.setCheckStatusCall = function (checkStatusCall) {
        this.checkStatusCall = checkStatusCall;
    };
    /**
     * Save isLoggedIn cookie from status response
     * @param loginDetails status response
     */
    // IMPORTANT: THIS FUNCTION WILL BE USEFUL WHEN LOGIN SERVICE IS FULLY IMPLEMENTED
    AuthenticationService.prototype.setLoggedInCookie = function (loginDetails) {
        var cookieValue = JSON.stringify({
            isLoggedIn: loginDetails.isLoggedIn
        });
        var expires = moment().add(this.durationIsLoggedInCookie, 'minutes').toDate();
        this.cookieService.set(COOKIES.isLoggedIn, cookieValue, expires, '/');
    };
    AuthenticationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.CookieService), i0.ɵɵinject(i3.HttpClient)); }, token: AuthenticationService, providedIn: "root" });
    return AuthenticationService;
}());
export { AuthenticationService };
